import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const sendMail = async (data) => {
    try {
        const response = await axios.post(API_URL + "api/sendMail", data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        return response.data;
    }
    catch (error) {
        return error;
    }
}

const keepAlive = async () => {
    try {
        await axios.get(API_URL);
    }
    catch (error) {
        return error;
    }
}

const DataService = {
    sendMail,
    keepAlive
}

export default DataService;